angular.module('gym').factory('MemberForms', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var gymId;
  gymId = $rootScope.toParams.gymId;
  return Restangular.one('gyms', gymId).all('forms').all('member_forms.json');
}]);
